import React, { useEffect, useState } from 'react';

// **************************************************
//      Construct: Import All Contruct Layouts
// **************************************************
import DynamicContainerLayout from "../../components/construct/layout/DynamicContainer";

export default function Construct({ layout, ...props }) {
    // App State

    // Component State
    const [layoutComponent, setLayoutComponent] = useState(<React.Fragment/>);

    // TODO: FUTURE: Make logic recursive i.e. embedded layouts
    // TODO: Move parse logic to utils specific to constructs
    // Configuration - pass [] so there is no watch
    useEffect(() => {
        // In this approach the first component is a layout / container
		// console.log('**** Construct **** ', layout.configuration);
        setLayoutComponent(<DynamicContainerLayout configuration={layout.configuration} {...props} />);
    }, [layout]);


    return (
        <React.Fragment>
            {layoutComponent}
        </React.Fragment>
    );
}
